import { render, staticRenderFns } from "./noteable_note.vue?vue&type=template&id=5008ab4b"
import script from "./noteable_note.vue?vue&type=script&lang=js"
export * from "./noteable_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports